// extracted by mini-css-extract-plugin
export default {"container":"styles_container_T1TtJ","header":"styles_header_Ct_yv","description":"styles_description_tFwdO"};